import { Profile, Stat, FeedItem, Opportunity } from '../../types';

export const MOCK_USERS: Profile[] = [
  {
    id: 'u1',
    full_name: '[DEMO] Jordan Baker',
    role: 'Athlete',
    sport: 'football',
    positions: ['QB'],
    school: 'Lincoln High',
    grad_year: 2026,
    height: '6\'2"',
    weight: '205 lbs',
    gpa: 3.85,
    avatar_url: 'https://i.pravatar.cc/150?u=jordan',
    social_handles: { twitter: '@jbaker_qb' },
    featured_stats: [],
    subscription_status: 'active',
    subscription_plan: 'monthly',
  },
  {
    id: 'u2',
    full_name: '[DEMO] Darius Miles',
    role: 'Athlete',
    sport: 'football',
    positions: ['WR', 'CB'],
    school: 'Westlake High',
    grad_year: 2025,
    avatar_url: 'https://i.pravatar.cc/150?u=darius',
    social_handles: { twitter: '@dmiles_wr' },
    subscription_status: 'trial',
    subscription_plan: 'none',
  },
  {
    id: 'u3',
    full_name: '[DEMO] Coach Miller',
    role: 'Coach',
    sport: 'football',
    school: 'State University',
    positions: ['Recruiting Coordinator'],
    grad_year: 0,
    avatar_url: 'https://i.pravatar.cc/150?u=miller',
    social_handles: { twitter: '@coach_miller' },
    subscription_status: 'active',
    subscription_plan: 'lifetime',
  },
];

export const MOCK_FEED: FeedItem[] = [
  {
    id: 'f1',
    user: MOCK_USERS[1],
    type: 'stat_update',
    content: 'Just hit a new PR on the bench press! Hard work paying off.',
    data: { name: 'Bench Press', value: '225 lbs' },
    timestamp: '2 hours ago',
    likes: 24,
    comments: 3,
  },
  {
    id: 'f2',
    user: MOCK_USERS[2],
    type: 'status',
    content: 'Great visit at West Lake High today. Lots of talent in the 2025 class.',
    timestamp: '5 hours ago',
    likes: 156,
    comments: 12,
  },
];

interface RankingEntry {
  id: string;
  name: string;
  school: string;
  value: string;
  rank: number;
}

export const RANKINGS_DATA: Record<string, RankingEntry[]> = {
  '40 Yard Dash': [
    { id: '1', name: '[DEMO] Jackson Reed', school: 'Westfield Prep', value: '4.41s', rank: 1 },
    { id: '2', name: '[DEMO] Jordan Baker', school: 'Lincoln High', value: '4.52s', rank: 2 },
    { id: '3', name: '[DEMO] Malik Young', school: 'St. John', value: '4.55s', rank: 3 },
  ],
  'Bench Press': [
    { id: '5', name: '[DEMO] Williams', school: 'Elite Performance Academy', value: '315 lbs', rank: 1 },
    { id: '6', name: '[DEMO] Jordan Baker', school: 'Lincoln High', value: '285 lbs', rank: 2 },
  ],
};

export const MOCK_STATS: Stat[] = [
  {
    id: 's1',
    user_id: 'u1',
    category: 'Speed',
    name: '40 Yard Dash',
    value: '4.52s',
    date_recorded: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    verification_status: 'verified',
  },
  {
    id: 's2',
    user_id: 'u1',
    category: 'Lifting',
    name: 'Bench Press',
    value: '285 lbs',
    date_recorded: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    verification_status: 'verified',
  },
  {
    id: 's3',
    user_id: 'u1',
    category: 'Lifting',
    name: 'Squat',
    value: '405 lbs',
    date_recorded: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
    verification_status: 'verified',
  },
  {
    id: 's4',
    user_id: 'u1',
    category: 'Speed',
    name: 'Vertical Jump',
    value: '34.5"',
    date_recorded: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    verification_status: 'pending',
  },
];

export const MOCK_OPPORTUNITIES: Opportunity[] = [
  {
    id: 'o1',
    title: 'Elite Prospects Combine',
    provider: 'Rivals.com',
    location: 'Atlanta, GA',
    date: 'July 15-16',
    price: '$129',
    type: 'combine',
    url: 'https://nkr.rivals.com/camps',
    trending: true,
  },
  {
    id: 'o2',
    title: 'D1 Exposure Camp',
    provider: 'National Recruiting',
    location: 'Dallas, TX',
    date: 'August 02',
    price: '$199',
    type: 'camp',
    url: 'https://www.ncsasports.org/football/football-camps',
    trending: false,
  },
];
